<template>
  <div v-if="splash" class="notlink splashLink" @click="toSite">
    <div id="splashOuter">
      <div id="splashInner">
        <div id="splashTop">
          <div v-html="splash.intro" id="iP"></div>
          <div v-html="splash.date" id="dP"></div>
        </div>

        <div id="splashBottom">
          <div id="notice" v-if="splash.notice" v-html="splash.notice"></div>
          <div id="more" v-if="splash.more" v-html="splash.more"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // data() {
  //   return {
  //     intro: null,
  //     date: null,
  //     iP: null,
  //     dP: null,
  //   };
  // },

  computed: {
    splash() {
      return this.$store.getters.splash;
    },

    offline() {
      return this.$store.getters.offline;
    },
  },

  mounted() {
    this.$root.$emit('scrollAfterEnter');
  },

  methods: {
    toSite() {
      let to = this.offline ? 'temporaire' : 'laureats';
      this.$router.push('/' + to);
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';

#splashTop {
  display: flex;
}

#iP {
  width: 60%;
}

#dP {
  width: 40%;
}

#splashBottom {
  display: flex;
  flex: 1;
}

#notice {
  margin-top: auto;
  width: 60%;
  font-size: $bodytype;
}

#more {
  margin-top: auto;
  width: 40%;
  font-size: $bodytype;

  p {
    margin: 0;
  }

  ul {
    padding: 0;
    margin: 0;
  }

  li {
    margin: 0 0 0 1.5rem;
  }
}

.splashLink {
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer !important;
  top: 0;
}

#splashOuter {
  width: 100%;
  min-height: 100%;
  display: flex;
  font-size: $mediumtype;
  padding: 18rem 8rem 2rem;

  a {
    text-decoration: underline;
  }
}

#splashInner {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  p:last-child {
    margin: 0;
  }
}

@media screen and (max-width: $breakPoint1) {
  #splashOuter {
    font-size: $bigtype;
    padding: 30vh 2rem 2rem;

    #notice {
      width: 60%;
      width: 100%;
      padding-bottom: 4rem;
      bottom: auto;
    }

    #more {
      width: 100%;
      padding-left: 5rem;
    }
  }

  #splashTop,
  #splashBottom {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  #iP {
    margin-bottom: 4rem;
    width: 100%;
  }

  #dP {
    padding-left: 10rem;
    margin-bottom: 4rem;
    width: 100%;
  }
}
</style>
